import heroAbout from '../../Images/About/heroAbout.svg';
import '../../Styles/Sass/OurStory.scss';

function OurStory() {
  return (
    <section className='ourStory'>
    	<img className='ourStory__hero' src={heroAbout} alt="" />
    	<div className='ourStory__textBox'>
	    	<h2 className='ourStory__title'>Our Story</h2>
	    	<p className='ourStory__text'>Who are we? We are you. Like-minded individuals that share a common goal to hire and be hired to clean at the highest level. Clean Connection is a singular platform for companies and homeowners looking to connect with cleaning services that meet your needs. We hold each other to the highest of standards in building and home cleaning services. Welcome to Clean Connection.</p>	
    	</div>
    </section>
  );
}

export default OurStory;
